<script>
   /**************************************************************/
   /* AppPlots component for test alternative app                */
   /* -------------------------------------------                */
   /* show selection of plot for testing of SIMCA model          */
   /**************************************************************/

   // local plot and plot controls components
   import AcceptancePlot from '../shared/AcceptancePlot.svelte';
   import DistancePlot from '../shared/DistancePlot.svelte';
   import AliensPlot from '../shared/AliensPlot.svelte';
   import ScoresPlot from '../shared/ScoresPlot.svelte';
   import SelectivityIntPlot from '../shared/SelectivityIntPlot.svelte';

   import AltAcceptancePlotControls from '../shared/AltAcceptancePlotControls.svelte';
   import DistancePlotControls from '../shared/DistancePlotControls.svelte';
   import AliensPlotControls from '../shared/AliensPlotControls.svelte';
   import ScoresPlotControls from '../shared/ScoresPlotControls.svelte';
   import SelectivityIntPlotControls from '../shared/SelectivityIntPlotControls.svelte';

   // import shared plot and plot controls components
   import AppPlots from '../shared/AppPlots.svelte';
   import SpecificityPlot from '../../../shared/plots/SpecificityPlot.svelte';
   import SelectivityPlot from '../../../shared/plots/SelectivityPlot.svelte';

   import SpecificityPlotControls from '../../../shared/plots/SpecificityPlotControls.svelte';
   import SelectivityPlotControls from '../../../shared/plots/SelectivityPlotControls.svelte';



   // input parameters
   export let model;
   export let simcares;
   export let pcares;
   export let datasets;
   export let ncomp;

   // array with list of plots and their components
   // parameter "scope" tells parent AppPlots component whether click events must be handled:
   // - for "objects" - it triggers click events on plots as selection of objects and mark them as outliers
   // - for "variables" - it triggers click events on plots as selection of variables (no more actions so far)
   // - for "none" - the click events will be ignored
   const options = [
      {label: 'Acceptance', scope: 'none', plotComponent: AcceptancePlot, controlsComponent: AltAcceptancePlotControls},
      {label: 'Distance (objects)', scope: 'none', plotComponent: DistancePlot, controlsComponent: DistancePlotControls},
      {label: 'Aliens', scope: 'none', plotComponent: AliensPlot, controlsComponent: AliensPlotControls},
      {label: 'Specificity', scope: 'none', plotComponent: SpecificityPlot, controlsComponent: SpecificityPlotControls},
      {label: 'Selectivity (vs. PCs)', scope: 'none', plotComponent: SelectivityPlot, controlsComponent: SelectivityPlotControls},
      {label: 'Selectivity (integral)', scope: 'none', plotComponent: SelectivityIntPlot, controlsComponent: SelectivityIntPlotControls},
      {label: 'Scores', scope: 'scores-ns', plotComponent: ScoresPlot, controlsComponent: ScoresPlotControls},
   ]
</script>


<AppPlots {model} {pcares} {simcares} {datasets} {options} {ncomp} />